import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import styles from './SearchCard.module.sass'

const LazyLoadImage = React.lazy(() =>
  import('react-lazy-load-image-component').then(module => ({
    default: module.LazyLoadImage
  }))
)

const SearchCard = ({
  thumbnail,
  credit,
  creditType,
  title,
  description,
  link,
  alt
}) => {
  const isHTML = description?.startsWith('<p>')

  return (
    <div className={styles.card}>
      <div>
        <a href={link} target="_blank" rel="noreferrer">
          <Suspense fallback={''}>
            <LazyLoadImage
              src={thumbnail}
              className={styles.img}
              effect="opacity"
              alt={alt}
            />
          </Suspense>
        </a>
      </div>
      <div className={styles.detail}>
        {creditType && creditType?.toUpperCase() !== 'IME' && (
          <p className={styles.credit}>
            {creditType && creditType?.toUpperCase() === 'EBAC-CE'
              ? `${creditType}`
              : `${credit} ${creditType}`}
          </p>
        )}
        <a href={link} target="_blank" rel="noreferrer">
          <p className={styles.title}>{title}</p>
        </a>
        {/* <p className={styles.description}>{description}</p> */}
        {!isHTML && (
          <p className={styles.description}>
            {description ? description + '...' : ''}
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className={styles.readmore}
            >
              read more
            </a>
          </p>
        )}
        {isHTML && (
          <span
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html:
                description.substring(-3, description.length - 4) +
                '...' +
                `<a href="` +
                link +
                `" style="margin-left:5px;" class="readmoreLink" target="_blank" rel="noreferrer">read more</a>` +
                '</p>'
            }}
          />
        )}
      </div>
    </div>
  )
}

SearchCard.propTypes = {
  thumbnail: PropTypes.string,
  credit: PropTypes.string,
  creditType: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  alt: PropTypes.string
}

export default SearchCard
